import { StringValues } from '../interfaces/undetermined';

// Constante que guarda el nombre de los atributos que recibe el API de junta directiva, segun nombre en los formularios
export const BOARDOFDIRECTORS: StringValues = {
    operation: "ope",
    entities: "ent",
    element: "elm",
    option: "opt",
    type: "tipo",
};
